module.exports = __webpack_public_path__ + "static/img/second_service.776752b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/second_service.png
// module id = bUD2
// module chunks = 0